import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../../../react-core/Flux/Dispatcher";
import { DrawdownCalculationStoreStatic } from "./DrawdownCalculationStoreStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const DrawdownCalculationStoreDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const DrawdownCalculationStoreStore: DrawdownCalculationStoreStatic = new DrawdownCalculationStoreStatic();
